module.exports = __webpack_public_path__ + "static/img/baoxian1.cb279ff6.png";